import { message } from "antd"
import { useCallback, useEffect, useState } from "react"
import { BASE_URL } from "services"
import http from "services/httpService"

const url = `${BASE_URL}/admin/who_i_am`

export default function useAdminData() {
    const [isLoading, setIsLoading] = useState(true)
    const [userProfile, setUserProfile] = useState(null)

    const getAuthStatus = useCallback(async () => {
        try {
            const AUTH_TOKEN = sessionStorage.getItem("token")
            http.setJwt(AUTH_TOKEN)
            const { data } = await http.get(url)
            const adminProfile = data?.data
            if (adminProfile) {
                setUserProfile(adminProfile)
            }
        } catch (error) {
            message.error(error.message)
        }finally{
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        getAuthStatus()
    }, [getAuthStatus])

    return {
        userProfile,
        isLoading,
        adminRole: userProfile?.admin_role,
        setUserProfile,
        refetch: getAuthStatus,
    }
}